import * as yup from "yup";

export const TD1AdminFormValidationSchema = yup.object().shape({
	province: yup.string().required("Province is required"),
	effectiveDate: yup.string().required("Effective Date is required"),
});
